import { Control } from "ol/control";

/**
 * Client wanted some kind of links to jump directly to "advertised area".
 */
export class JumperControl extends Control {
	constructor(applicationTitle) {
		let articleNode = document.createElement("article");
		articleNode.className = "ol-unselectable ol-control";
		articleNode.id = "jumpContainer";

		super({ element: articleNode });
		this.jumpLinkFactory("https://web.geocodis.si/ground-move-map/", "img/EO4MASRISKtemp.png");

		this.jumpLinkFactory("https://www.geo-zs.si/", "img/geozs.png");
		this.jumpLinkFactory("https://www.geocodis.si/", "img/geocodis.png");

		/* const titleNode = document.createElement("abbr");
		titleNode.innerText = applicationTitle;
		titleNode.title = "Ground Deformation Detection and Risk Information Service";
		this.element.append(titleNode); */

		this.jumpLinkFactory("https://www.fgg.uni-lj.si/", "img/fgg.png");
		this.jumpLinkFactory("https://www.space.si/", "img/esa.png");
	}

	jumpLinkFactory = (externalURL, imageURL) => {
		if (!externalURL || !imageURL) return;
	
		let linkNode = document.createElement("a");
		linkNode.href = externalURL;
		linkNode.target = "_blank";
		linkNode.classList.add("jump-link"); // Add class for styling
	
		const imageNode = document.createElement("img");
		imageNode.src = imageURL;
		imageNode.alt = imageURL;
		imageNode.classList.add("jump-image"); // Add class for styling
	
		linkNode.append(imageNode);
		this.element.append(linkNode);
	};
	

}
